import {
  PreliminaryPrice,
  PriceChange,
  PriceHistory,
  preliminaryPriceSchema,
  price,
  priceChangeSchema,
  Resolution,
} from '@api';
import { apiFetch, wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const getPreliminaryPrice = (
  subscribableTicker: string,
  signal?: AbortSignal
) => {
  return apiFetch<PreliminaryPrice>(
    price.preliminaryPrice.path(subscribableTicker),
    {
      schema: preliminaryPriceSchema,
      options: { signal },
    }
  );
};

export type GetPricesProps = {
  ticker?: string;
  entityTag: string;
  resolution: Resolution;
  dateFrom?: string;
  dateTo?: string;
};

export const getPrices = async ({
  ticker,
  entityTag,
  resolution,
  dateFrom,
  dateTo,
}: GetPricesProps) => {
  let params = new URLSearchParams();

  if (ticker) {
    params.append('ticker', ticker);
  }

  if (dateFrom) {
    params.append('from', dateFrom);
  }

  if (dateTo) {
    params.append('to', dateTo);
  }

  params.append('entity_tag', entityTag);
  params.append('resolution', resolution);

  const priceUrl = `${price.prices.path}?${params.toString()}`;

  return apiFetch<PriceHistory>(priceUrl);
};

export const fetchPrices = async ({
  ticker,
  entityTag,
  resolution,
  dateFrom,
  dateTo,
}: GetPricesProps) => {
  let params = new URLSearchParams();

  if (ticker) {
    params.append('ticker', ticker);
  }

  if (dateFrom) {
    params.append('from', dateFrom);
  }

  if (dateTo) {
    params.append('to', dateTo);
  }

  params.append('entity_tag', entityTag);
  params.append('resolution', resolution);

  const priceUrl = `${price.prices.path}?${params.toString()}`;

  return wretchRequest<PriceHistory>(priceUrl);
};

export interface GetPriceChangeProps {
  ticker: string;
  reference: string;
  from: string;
  to: string;
}

export const getPriceChange = async ({
  ticker,
  from,
  to,
  reference,
}: GetPriceChangeProps) => {
  const params = new URLSearchParams({
    ticker,
    from,
    to,
    reference,
  });

  const priceUrl = `${price.priceChange.path}?${params.toString()}`;

  return wretchRequest<PriceChange>(priceUrl, {
    schema: priceChangeSchema,
    method: 'get',
  });
};
